import { render, staticRenderFns } from "./tax.vue?vue&type=template&id=7c02c202&scoped=true"
import script from "./tax.vue?vue&type=script&lang=js"
export * from "./tax.vue?vue&type=script&lang=js"
import style0 from "./tax.vue?vue&type=style&index=0&id=7c02c202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c02c202",
  null
  
)

export default component.exports